"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTableSortableHeaderCell = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TableSortableHeaderCellMixin = require("../../mixins/components/TableSortableHeaderCellMixin");
var _TableHeaderCell = require("../TableHeaderCell/TableHeaderCell.styles");
var StyledTableSortableHeaderCell = /*#__PURE__*/(0, _styledComponents.default)(_TableHeaderCell.StyledTableHeaderCell).withConfig({
  displayName: "StyledTableSortableHeaderCell",
  componentId: "c11n-8-107-0__sc-mod41s-0"
})(["", ""], _TableSortableHeaderCellMixin.TableSortableHeaderCellMixin);
exports.StyledTableSortableHeaderCell = StyledTableSortableHeaderCell;